import { createResource } from "./api";

// Report feed content (a comment or feed post) for moderation. Writes go through
// the Rails endpoint (JSON:API envelope); createResource injects auth + token
// refresh. The report is idempotent server-side (one per profile per target); a
// repeat report revises the reason/description.
const create = async ({ reportableType, reportableId, reason, description = null }) => {
  const attributes = {
    reportable_type: reportableType,
    reportable_id: String(reportableId),
    reason,
  };
  if (description) attributes.description = description;
  return createResource("/interact/api/reports", { data: { attributes } });
};

export default { create };
